import { AVATARS, NAME_ADJECTIVES, NAME_ANIMALS } from "@playpal/core";

const STORAGE_KEY = "playpal.identity";

export interface Identity {
	/** Opaque, stays in this browser, lets a dropped player get their seat back. */
	playerId: string;
	name: string;
	avatar: string;
}

const pick = <T>(items: readonly T[]): T => items[Math.floor(Math.random() * items.length)];

export function randomName(): string {
	return `${pick(NAME_ADJECTIVES)} ${pick(NAME_ANIMALS)}`;
}

export function randomAvatar(): string {
	return pick(AVATARS);
}

function newPlayerId(): string {
	return crypto.randomUUID();
}

export function loadIdentity(): Identity {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw) {
			const saved = JSON.parse(raw) as Partial<Identity>;
			if (saved.playerId && saved.name && saved.avatar) return saved as Identity;
		}
	} catch {
		// A blocked or full localStorage just means a fresh name each visit.
	}
	const identity = {
		playerId: newPlayerId(),
		name: randomName(),
		avatar: randomAvatar(),
	};
	saveIdentity(identity);
	return identity;
}

export function saveIdentity(identity: Identity): void {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(identity));
	} catch {
		// Not being able to remember the name is survivable.
	}
}
